import { render } from "./mobile.vue?vue&type=template&id=77fd3b2a&scoped=true"
import script from "./mobile.vue?vue&type=script&lang=js"
export * from "./mobile.vue?vue&type=script&lang=js"

import "./mobile.vue?vue&type=style&index=0&id=77fd3b2a&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/t3_d_M4E/0/hellmanh/rb-app-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77fd3b2a"]])

export default __exports__